import { Pipe, PipeTransform } from '@angular/core';
import { translateTerminalStatus } from '../mappers/enum-translation-mapper';
import { TerminalStatus } from 'src/app/features/payment-terminal/pts/pts-payment-terminal-model';

@Pipe({
  name: 'translateTerminalStatusEnum',
})
export class TranslateTerminalStatusEnumPipe implements PipeTransform {
  transform(value: TerminalStatus | null | undefined): string {
    if (!value) return '';
    return translateTerminalStatus(value);
  }
}
